import { render, staticRenderFns } from "./BrandBySupplier.vue?vue&type=template&id=75e9e83b&scoped=true&"
import script from "./BrandBySupplier.vue?vue&type=script&lang=js&"
export * from "./BrandBySupplier.vue?vue&type=script&lang=js&"
import style0 from "./BrandBySupplier.vue?vue&type=style&index=0&id=75e9e83b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e9e83b",
  null
  
)

export default component.exports